module.exports = __webpack_public_path__ + "assets/img/atobe112.c9280569.png";